module.exports = __webpack_public_path__ + "img/icon_category_05_w.c4f7835a.svg";